// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1qOtJ","title":"BackImages_title__3rIIB","images":"BackImages_images__g5_s6"};